import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "description",
  "use": "description-usage",
  "viewBox": "0 0 17 15",
  "content": "<symbol viewBox=\"0 0 17 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"description\"><path d=\"M3.3915 12.85H3.24279L3.10533 12.9067L0.75 13.879V1.7C0.75 1.17431 1.1756 0.75 1.6915 0.75H15.2915C15.8123 0.75 16.2415 1.17922 16.2415 1.7V11.9C16.2415 12.4208 15.8123 12.85 15.2915 12.85H3.3915Z\" stroke=\"#999\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol